import React, { FC, ReactElement, FormEvent, useState } from 'react';
import { sendQuestionMessage } from '../../../api';
import Modal from 'react-modal';
import Icon from '../../Icon';
import './speaker-question-modal.sass';
import { useSelector } from 'react-redux';
import { getEventKey } from '../../../stores/reducers/userData';
import { toast } from 'react-toastify';
import { getIsLoggedIn } from '../../../stores/reducers/userData';
import { internalizationState } from '../../../stores/reducers/sections';
import localeFieldResolver from '../../../helpers/locale-field-finder';

Modal.setAppElement('#root');

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  recepient?: string;
}

const SpeakerQuestionModal: FC<Props> = ({ isOpen, closeModal, recepient }): ReactElement => {
  const [ userName, setUserName ] = useState<string>('');
  const [ email, setEmail ] = useState<string>('');
  const [ message, setMessage ] = useState<string>('');
  const eventKey = useSelector(getEventKey);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const { activeLangState } = useSelector(internalizationState);

  const localizeData = {
    successMessageSend_ru: 'Сообщение успешно отправлено',
    successMessageSend_en: 'Message sent successfully',
    errorMessageSend_ru: 'Ошибка отправки сообщения',
    errorMessageSend_en: 'Error sending message',
    askQuestion_ru: `Задать вопрос ${recepient ? recepient : ''}`,
    askQuestion_en: `Ask a question ${recepient ? recepient : ''}`,
    name_ru: 'Имя',
    name_en: 'Name',
    messagePlaceholder_ru: 'Сообщение',
    messagePlaceholder_en: 'Message',
    askQuestionBtn_ru: 'Задать вопрос',
    askQuestionBtn_en: 'Ask a Question',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);
  
  const handlerSend = ((event: FormEvent): void => {
    event.preventDefault();
    const payload = {
      page: 'Спикеры',
      to: recepient,
      message
    };

    const payloadForUnauthorized = {
      page: 'Спикеры',
      to: recepient,
      message,
      email,
      name: userName
    };
    
    sendQuestionMessage(eventKey, isLoggedIn ? payload : payloadForUnauthorized)
      .then(response => {
        if (response.status === 200) {
          toast.success(localizedName('successMessageSend_ru'));
        } else {
          toast.error(localizedName('errorMessageSend_ru'));
        }
      })
      .catch(error => {
        toast.error(localizedName('errorMessageSend_ru'));
      })
      .finally(() => handlerClose());
  })

  const handlerClose = (): void => {
    closeModal()
    setMessage('')
  }

  const updateUserNameState = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserName(event.target.value);
  };

  const updateEmailState = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const updateMessageState = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  const disabledCondition = (): boolean => {
    let isDisabled = true;

    if (isLoggedIn) {
      if (message) {
        isDisabled = false;
      }
    } else {
      if (message && email && userName) {
        isDisabled = false;
      }
    }

    return isDisabled;
  };

  return (
    <>
    <Modal
      className="modal-login-content speakers-questions-modal"
      overlayClassName="modal-login-overlay"
      isOpen={isOpen}
      onRequestClose={handlerClose}
    >
      <h3 className="modal-title">{ localizedName('askQuestion_ru') }</h3>
      <button className="modal-close" type="button" onClick={handlerClose} style={{transform: 'scale(0.8)'}}>
        <Icon name="close" />
      </button>
      <form className="modal-form" onSubmit={(e) => handlerSend(e)}>
        {
          !isLoggedIn && 
          <>
            <label className="form-label">{localizedName('name_ru')}</label>
            <input
              id="name"
              name="name"
              className="ui-input modal-input"
              placeholder={localizedName('name_ru')}
              maxLength={255}
              value={userName}
              onChange={updateUserNameState}
            />
            <label className="form-label">Email</label>
            <input
              id="email"
              name="email"
              className="ui-input modal-input"
              placeholder="Email"
              maxLength={255}
              value={email}
              onChange={updateEmailState}
            />
          </>
        }
        <label className="form-label">{ localizedName('messagePlaceholder_ru') }</label>
        <textarea
          id="message"
          className="ui-input modal-textarea"
          placeholder={localizedName('messagePlaceholder_ru')}
          maxLength={1500}
          value={message}
          onChange={updateMessageState}
        />
        <div className="form-buttons">
          <button
            type="submit"
            className="btn btn-primary bg-header"
            disabled={disabledCondition()}
          >
            { localizedName('askQuestionBtn_ru') }
          </button>
        </div>
      </form>
    </Modal>
    </>
  )
}

export default SpeakerQuestionModal
